require('./validator');

import $ from 'jquery';
import validate from 'jquery-validation';
import { getTranslatedMessages } from '../../translates';
import { setupSelectCountryStateCity } from './form-helper';
validate;

$.validator.addMethod(
    'phoneBR',
    function (value, element) {
        var countryId = $('#country_id').val();
        if (countryId != '1') {
            return true; // Se country_id não for 1, não valida o telefone
        }

        var cleaned = value.replace(/\D/g, '');
        return /^(\d{10}|\d{11})$/.test(cleaned);
    },
    getTranslatedMessages().phone.phoneBr
);

function setupContactForm() {
    const locale = window.currentLocale();
    var $contactForm = $('.contact-form');
    var $btnSubmit = $contactForm.find('.btn-submit');
    const country = $('input[name="country"]');
    const selectState = $('select[name="state_id"]');
    const selectCity = $('select[name="city_id"]');

    if (locale != 'pt_BR') {
        country.parent().removeClass('hidden');
        selectCity.parent().hide();
        selectState.parent().hide();
    }

    console.log(locale);

    $contactForm.validate({
        rules: {
            name: 'required',
            email: {
                required: true,
                email: true,
            },
            phone: {
                required: true,
                minlength: {
                    param: 8,
                    depends: function (element) {
                        // 1 = Brasil
                        return $('#country_id').val() != '1';
                    },
                },
                maxlength: {
                    param: 13,
                    depends: function (element) {
                        // 1 = Brasil
                        return $('#country_id').val() != '1';
                    },
                },
                phoneBR: {
                    depends: function (element) {
                        // 1 = Brasil
                        return $('#country_id').val() == '1';
                    },
                },
            },
            city_id: 'number',
            state_id: 'number',
            country: locale == 'pt_BR' ? null : 'required',
            message: 'required',
        },
        messages: getTranslatedMessages(),
        submitHandler: function (form, event) {
            if ($btnSubmit.hasClass('loading')) {
                return;
            }

            $btnSubmit.addClass('loading');

            event.preventDefault();
            event.stopPropagation();

            reloadCaptcha('contact', 'g-recaptcha-response', function () {
                var $form = $(form);

                $.ajax({
                    type: 'POST',
                    url: $(form).data('action'),
                    data: $(form).serialize(),
                    success: function (data) {
                        form.reset();
                        $btnSubmit.removeClass('loading');
                        $contactForm.find('.form-feedback').html(data);
                    },
                    error: function (data) {
                        $contactForm.find('.form-feedback').empty();
                        $btnSubmit.removeClass('loading');

                        $contactForm
                            .find('.form-errors')
                            .html(
                                data.responseJSON && data.responseJSON.errors
                                    ? Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>')
                                    : data.responseJSON.message || data.responseText
                            )
                            .show({ duration: 0 });

                        try {
                            reloadCaptcha('contact');
                        } catch (e) {
                            console.log(e);
                        }
                    },
                });
            });
        },
    });
}

function initialize() {
    setupContactForm();

    setupSelectCountryStateCity($('.contact-form'));

    // setupSelectStateCity($('.contact-form'));
}

initialize();
